export const UPDATE_JOB_ALERT_REQUEST = 'UPDATE_JOB_ALERT_REQUEST'
export const UPDATE_JOB_ALERT_SUCCESS = 'UPDATE_JOB_ALERT_SUCCESS'
export const UPDATE_JOB_ALERT_FAILED = 'UPDATE_JOB_ALERT_FAILED'
